import { render, staticRenderFns } from "./AboutUs.html?vue&type=template&id=232de7fe&scoped=true&external"
import script from "./AboutUs.js?vue&type=script&lang=js&external"
export * from "./AboutUs.js?vue&type=script&lang=js&external"
import style0 from "./AboutUs.scss?vue&type=style&index=0&id=232de7fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232de7fe",
  null
  
)

export default component.exports